module.exports = __webpack_public_path__ + "static/media/yellow-rose.8c22adca.png";